import axios, { AxiosResponse } from "axios";
import {
	PowUserResponse,
	UserAuditHistoryResponse,
	EditPowUserResponse,
	EditPowUserRequest,
} from "../../models/Administration";

export const getAllUsers = () => async (): Promise<AxiosResponse<PowUserResponse[]>> => {
	return await axios.get(`/api/v1/Authorization/users`);
};

export const addUser = (userPrincipalName: string) => async (): Promise<AxiosResponse> => {
	return await axios.post(`/api/v1/Authorization/users`, { UserPrincipalName: userPrincipalName });
};

export const deleteUser = (userPrincipalName: string) => async (): Promise<AxiosResponse> => {
	return await axios.delete(`/api/v1/Authorization/users/${userPrincipalName}`);
};

export const getPowUserAuditHistory =
	(userPrincipalName: string) => async (): Promise<AxiosResponse<UserAuditHistoryResponse[]>> => {
		return await axios.get(`/api/v1/Authorization/users/${userPrincipalName}/auditHistory`);
	};

export const editPowUser =
	(request: EditPowUserRequest, userPrincipalName: string) => async (): Promise<AxiosResponse<EditPowUserResponse>> => {
		return await axios.put(`/api/v1/Authorization/users/${userPrincipalName}`, request);
	};

export const getPowUserDetails = (userPrincipalName: string) => async (): Promise<AxiosResponse<PowUserResponse>> => {
	return await axios.get(`/api/v1/Authorization/users/${userPrincipalName}`);
};

export const getAllProductsWithRoles = () => async (): Promise<AxiosResponse<object>> => {
	return await axios.get(`/api/v1/Authorization/products`);
};
